import styles from './Spinner.module.scss';

export const Spinner = () => {
  return (
    <div className={`${styles.ldsSpinner} lds-spinner`}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
